import Paper from '@material-ui/core/Paper'
import { withStyles, WithStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import { Theme } from '@material-ui/core/styles/createTheme'
import Typography from '@material-ui/core/Typography'
import WarningIcon from '@material-ui/icons/Warning'
import React from 'react'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.error.main,
      boxShadow: 'none',
      padding: theme.spacing(),
    },
    warnMessageText: {
      color: 'white',
      display: 'flex',
      alignItems: 'center',
    },
    warnMessageIco: {
      margin: theme.spacing(),
    },
  })

interface IWarnMessage extends WithStyles {
  message: string
}

const WarnMessage = (props: IWarnMessage) => {
  const { classes, message } = props
  return (
    <Paper className={classes.root} elevation={1}>
      <Typography variant="h6" className={classes.warnMessageText}>
        <WarningIcon className={classes.warnMessageIco} />
        {message}
      </Typography>
    </Paper>
  )
}

export default withStyles(styles)(WarnMessage)
